import React, { useState } from 'react';
import ConfirmationModal from '../../components/UI/ConfirmationModal';
import './AddTenantModal.css';

const AddTenantModal = ({ onClose, onAdd }) => {
  const [name, setName] = useState('');
  const [brandFile, setBrandFile] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [confirmIsError, setConfirmIsError] = useState(false);

  const handleAddClick = () => {
    if (!name.trim()) {
      setConfirmMessage('Tenant name is required.');
      setConfirmIsError(true);
      setShowConfirmModal(true);
      return;
    }
    onAdd(name.trim(), brandFile);
    setConfirmMessage('Tenant added successfully!');
    setConfirmIsError(false);
    setShowConfirmModal(true);
  };

  return (
    <>
      <div className="add-tenant-backdrop">
        <div className="add-tenant-modal">
          <h2>Add Tenant</h2>
          <div className="add-tenant-input-group">
            <label className="add-tenant-label">
              Tenant Name
            </label>
            <input
              type="text"
              placeholder="Enter tenant name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="add-tenant-input"
            />
          </div>

        <div className="add-tenant-input-group">
          <label className="add-tenant-label">
            Branding File (.zip)
          </label>
          <input
            type="file"
            accept=".zip"
            onChange={(e) => {
              if (e.target.files?.[0]) {
                setBrandFile(e.target.files[0]);
              } else {
                setBrandFile(null);
              }
            }}
            className="add-tenant-input"
            data-testid="branding-file-input"
          />
        </div>

          <div className="add-tenant-actions">
            <button onClick={onClose} className="add-tenant-button cancel">
              Cancel
            </button>
            <button onClick={handleAddClick} className="add-tenant-button add">
              Add Tenant
            </button>
          </div>
        </div>
      </div>

      {showConfirmModal && (
        <ConfirmationModal
          isOpen={showConfirmModal}
          message={confirmMessage}
          confirmLabel="OK"
          showCancel={false}
          isDanger={confirmIsError}
          onConfirm={() => {
            setShowConfirmModal(false);
            if (!confirmIsError) {
              onClose();
            }
          }}
        />
      )}
    </>
  );
};

export default AddTenantModal;
